import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { toast } from "react-toastify";

const DropZone = ({ setFieldValue, File }) => {
  const [files, setFiles] = useState(File || []);
   useEffect(() => {
  setFiles(File || []);
}, [File]);

const MAX_FILES = 20;

const onDrop = useCallback(
  (acceptedFiles) => {
    if (files.length >= MAX_FILES) {
      toast.error("You can upload a maximum of 20 images.");
      return;
    }

    const remaining = MAX_FILES - files.length;
    const filesToAdd = acceptedFiles.slice(0, remaining);
    const newFiles = [...files, ...filesToAdd];

    if (acceptedFiles.length > remaining) {
      toast.error("Only 20 images are allowed.");
    }

    setFiles(newFiles);
    setFieldValue("files", newFiles);
  },
  [files, setFieldValue]
);

//   const onDrop = useCallback(
//     (acceptedFiles) => {
//       const newFiles = [...files, ...acceptedFiles];

//       setFiles(newFiles);
//       setFieldValue("files", newFiles);
//     },
//     [files, setFieldValue]
//   );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    // maxSize: 26214400,
    accept:".jpg,.jpeg,.png,.webp",
  });

  const removeFile = (index) => {
    const updated = [...files];
    updated.splice(index, 1);

    setFiles(updated);
    setFieldValue("files", updated);
  };

 

  return (
    <UploadBox {...getRootProps()}>
      <input {...getInputProps()} />

      {files.length === 0 ? (
        <UploadText>
          <img src={Images.Upload} alt="" className="w-5 mb-1" />
          <p className="text-xs">Click or Drag Images To Upload</p>
          <span className="text-xs">
            (JPG, PNG, JPEG, WEBP)
          </span>
          <span className="text-xs">
             Maximum 20 images (Up to 10 MB each)
          </span>
        </UploadText>
      ) : (
        <FileContainer>
          {files.map((file, index) => (
            <FileItem key={index}>
                <FileName>{file.name}</FileName>

                <RemoveBtn
                    onClick={(e) => {
                    e.stopPropagation();
                    removeFile(index);
                    }}
                >
                    <img src={Images.Cross} className="w-2" alt="" />
                </RemoveBtn>
            </FileItem>
          ))}
           <div className="text-sm text-primary-color font-bold text-center underline hover:text-blue-600">Click to upload more...</div>
        </FileContainer>
      )}
    </UploadBox>
  );
};

const FileName = tw.span`
flex-1
min-w-0
mr-2
overflow-hidden
text-ellipsis
whitespace-nowrap
`;

const UploadBox = tw.div`
w-full min-h-[120px] border-2 borde border-gray-300 
bg-gray-50 rounded-md p-4 cursor-pointer
`;

const UploadText = tw.div`
flex flex-col items-center justify-center text-gray-600 text-sm h-full
`;

const FileContainer = tw.div`
flex flex-col gap-2
`;

const FileItem = tw.div`
flex justify-between items-center bg-gray-100 
p-2 rounded text-sm text-gray-600
`;

const RemoveBtn = tw.div`
bg-black w-5 h-5 rounded-full flex items-center justify-center cursor-pointer
`;

export default DropZone;